import { createApp } from 'vue';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import ui from './ui-factory';
import ViewUIPlus from 'view-ui-plus';
import { getDevicePage } from '@/lib/device';
import createContainer from '@/global/app-container';
import { register } from '@yanxiu/directive-link';
import * as Sentry from '@sentry/vue';
import { getTokenByTicket } from '@/global/container/app-context';
import { getQueryString } from '@/lib/tools';
import { getIsPortalEnabled } from '@/hooks/useIsPortalEnabled';
import { pickHomeNavUrlFromMenus, resolveHomeNavUrlForGuard } from '@/lib/resolve-home-nav-url';
import 'view-ui-plus/dist/styles/viewuiplus.css';
import WujieVue from 'wujie-vue3';

const view = createContainer('app')(App);
var app = createApp(view);
register(app);

if (process.env.VUE_APP_SENTRY_DSN != '') {
    Sentry.init({
        app,
        dsn: process.env.VUE_APP_SENTRY_DSN, // DSN告诉 SDK 将事件发送到哪里。如果未提供此值，SDK 将尝试从环境变量中读取它SENTRY_DSN。如果该变量也不存在，SDK 将不会发送任何事件。
        // integrations: [new Integrations.BrowserTracing()], // 在某些 SDK 中，集成是在库初始化时通过此参数配置的。这可用于禁用默认添加的集成。设置为false时，不添加默认集成。
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: ['localhost', 'local.3ren.cn', /^\//],
            }),
        ],
        release: process.env.VUE_APP_RELEASE_VERSION, // 设置版本号，需要与vue.config中的版本号一致
        tracesSampleRate: 1.0, // 一个介于 0 和 1 之间的数字，控制将给定交易发送到 Sentry 的百分比机会。（0 代表 0%，而 1 代表 100%。）同样适用于应用程序中创建的所有交易。tracesSampler必须定义这个或才能启用 追踪记录请求期间发生的事件的过程，通常跨多个服务。
        logErrors: true, // 决定SDK是否也应该调用Vue的原始函数。
        // trackComponents: true, // 跟踪您应用的组件。
        // hooks: ['activate', 'create', 'destroy', 'mount', 'update'] // 控制应跟踪哪些生命周期挂钩。
    });
}

// 路由检测符合跳转条件则转入对应手机端路由
router.beforeEach((to, from) => {
    if (to.name) {
        getDevicePage({
            routeName: to.name as string,
            queries: to.query,
            params: to.params,
            mobile: 'appstrain',
            web: 'idx',
            curDevice: 'web',
        });
    }
});

// 首页：门户关闭 → 个人中心；门户开启 → 使用 getModuleUrl 解析中台首页 moduleKey
router.beforeEach(async to => {
    if (to.name !== 'home') {
        return;
    }
    const pagePermission = store.state.pagePermission;
    const portalEnabled = getIsPortalEnabled(pagePermission);
    if (!portalEnabled) {
        return { name: 'userHomePage' };
    }
    try {
        const [menus, moduleUrlMap] = await Promise.all([
            store.state.user.menuList?.length
                ? Promise.resolve(store.state.user.menuList)
                : store.dispatch('user/getNavList'),
            store.dispatch('user/getModuleList'),
        ]);
        const rawTarget = pickHomeNavUrlFromMenus(menus, moduleUrlMap);
        const next = resolveHomeNavUrlForGuard(rawTarget);
        return next === null ? undefined : next;
    } catch {
    }
});

// 注册ui库组件
if (process.env.VUE_APP_SSO_Login_URL) {
    // 通过公共登录平台（cas.yanxiu.com）登录，会生成ticket,项目中用query中的ticket替换成token种下
    getTokenByTicket(res => {
        store.dispatch('loginSuccess', {
            access_token: res.data,
            keepCookie: !!getQueryString(window.location.href, 'keepCookie'),
        });
    }).finally(() => {
        ui.register(app).use(WujieVue).use(store).use(router).use(ViewUIPlus).mount('#app');
    });
} else {
    ui.register(app).use(WujieVue).use(store).use(router).use(ViewUIPlus).mount('#app');
}
